import React from 'react';
import {
  FormControl,
  Input,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormHelperText,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  select: {
    borderRadius: 2,
    width: '100%',
    maxWidth: 536,
    border: '1px solid rgb(150,150,150)',
    '&:hover': {
      border: '1px solid rgba(0, 0, 0, 0.87)',
    },
  },
  heightSelect : {
    minHeight: 76,
    maxWidth:536
  },
  selectRoot: {
    height: 'auto',
    overflow: 'auto',
    whiteSpace: 'normal',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  selectMenu: {
    padding: '10px 14px',
    fontSize: 16,
    lineHeight: 1,
  },
  inputLabelRoot: {
    transform: 'translate(14px, 32px) scale(1)',
  },
  inputLabelShrink: {
    transform: 'translate(14px, 9px) scale(0.75)',
    backgroundColor: '#fff',
    zIndex: 10,
  },
  listItemText: {
    fontSize: 14,
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  inputError: {
    border: '1px solid #d74242',
    '&:hover': {
      border: '1px solid #d74242',
    },
  },

}));

const specialtiesOptions = [
  'Accidentes Viales',
  'Acoso Sexual',
  'Arquitectura Legal',
  'Comercio Internacional',
  'Concursos y Quiebras',
  'Defensa de la Competencia',
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      maxWidth: 536,
      width: '100%',
    },
  },
};

export default function MultipleSelect(props) {
  const classes = useStyles();
  const {
    specialties,
    handleBlur,
    handleChange,
    touchedSpecialty,
    errorsSpecialty,
  } = props;
 

  return (
    <FormControl  classes={{ root: classes.heightSelect }} error={touchedSpecialty && errorsSpecialty ? true : false}>
      <InputLabel
        htmlFor="select-multiple-checkbox"
        classes={{
          root: classes.inputLabelRoot,
          shrink: classes.inputLabelShrink,
        }}
      >
        Áreas de especialidad*
      </InputLabel>
      <Select
        id="specialties"
        name="specialties"
        multiple
        value={specialties}
        onBlur={handleBlur}
        onChange={event => {
          handleBlur(event);
          handleChange(event);
        }}
        input={
          <Input
            id="select-multiple-checkbox"
            classes={{ error: classes.inputError }}
          />
        }
        renderValue={selected => selected.join(', ')}
        MenuProps={MenuProps}
        className={classes.select}
        classes={{
          root: classes.selectRoot,
          selectMenu: classes.selectMenu,
        }}
        disableUnderline={true}
      >
        {specialtiesOptions.map(specialty => (
          <MenuItem key={specialty} value={specialty}>
            <Checkbox
              color="primary"
              checked={specialties.indexOf(specialty) > -1}
              className={classes.checkbox}
            />
            <ListItemText
              primary={specialty}
              classes={{
                primary: classes.listItemText,
              }}
            />
          </MenuItem>
        ))}
      </Select>
      {touchedSpecialty && errorsSpecialty ? (
        <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
          {errorsSpecialty}
        </FormHelperText>
      ) : (
        ''
      )}
    </FormControl>
  );
}
